import { Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AppInsightsService {
  private appInsights: ApplicationInsights;

  constructor() {
    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: environment.instrumentationKey
      }
    });
    this.appInsights.loadAppInsights();
  }

  trackPageView(pageName?: string, username?: string) {
    this.appInsights.trackPageView({
      name: pageName,
      properties: {
        UserName: username,
          ApplicationCode: environment.appcode,
        DeviceType: this.getDeviceType()
       }
    });
  }

  getDeviceType(): string {
    const userAgent = navigator.userAgent || navigator.vendor;

    if (/android/i.test(userAgent)) {
      return 'Android Mobile';
    } else if (/iPad|iPhone|iPod/.test(userAgent)) {
      return 'iOS Mobile';
    } else if (/Macintosh/.test(userAgent)) {
      return 'Mac';
    } else {
      return 'Desktop';
    }
  }
}
